<script>
import tabNavi from "./sub/urTabNavi"

const TAG_LABEL = "urTabLabel";
const TAG_CONTS = "urTabContent";
const TYPE_LABEL = "label";
const TYPE_LEFT = "left";
const TYPE_RIGHT = "right";

// ur-tab-box는 각종 ur-tab-label, ur-tab-content 등의 모태가 되는 컴포넌트로,
// ur-tab-box 구성 요소는 선택 가능한 항목 뒤에 내용을 숨기는 데 사용됩니다.
// #ur-tab-box is a component that forms the basis of various ur-tab-label, ur-tab-content, etc.
// #The ur-tab-box component is used to hide content behind selectable items.
export default {
    name:'urTabBox',
    data:function() {return {
        currIdx : null,
        tabCnt : 0,
        // idxMap : new Map(),
        // idxs : []
    }},
    props:{
        // $ver: v0.2.0
        // 크기 입니다. 'medium','small' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of two types: medium or small.
        // $default: medium
        // $tags IDE, size
        size: { type: String },
        // $ver: v0.1.0
        // 라벨 영역을 작은 모양으로 표시합니다.
        // #This flag turns shapes of label area to smaller.
        // $default: false
        // $tags size
        small:Boolean,
        // $ver: v0.2.1
        // 라벨 영역을 중간 크기로 표시합니다.
        // #This flag turns shapes of label area to medium size.
        // $default: false
        // $tags size
        medium:Boolean,
        // $ver: v0.2.0
        // 모양입니다. 'border','underline','none' 중 하나를 입력해야 합니다.
        // #The shape. You must enter one of three types: border, underline, none
        // $default: border
        // $tags IDE, shape
        shape: {type: String},
        // $ver: v0.2.0
        // 컴포넌트를 Underline 형태로 표현합니다.
        // #Represents a component in underline form.
        // $default: false
        // $tags shape
        underline: {type:Boolean, default: false},
        // $ver: v0.2.1
        // 컴포넌트를 Border 형태로 표현합니다.
        // #Represents a component in border form.
        // $default: false
        // $tags shape
        border: {type:Boolean, default: false},
        // $ver: v0.1.0
        // 최초 표시할 탭의 index를 지정합니다.
        // #it defines tab index to display on init.
        // $default: null(first index of tabs)
        // $tags IDE, defaultIdx
        defaultIdx: [String, Number],
        // $ver: v0.2.1
        // 네비게이션 버튼 표시 유무를 결정합니다.
        // #This flag controls show a navigation button or not.
        // $default: false
        navigation: {type:Boolean, default: false},
        // $ver: v0.2.1
        // Tab 추가 버튼표시 유무를 결정합니다.
        // 실제 물리적 탭 추가 기능은 컴포넌트에서 제공하지 않으며, 단지 버튼과 이벤트만 제공합니다.
        // Tab 추가 sample을 확인해주세요.
        // #This flag controls show a add button or not.
        // #Tab component does not offer add real tab. This options is only for add button & event
        // #Please check "Editable Tab" sample
        // $default: false
        addBtn: {type:Boolean, default: false},
    },
    created() {
        // 1. Check default index
        if( (this.defaultIdx === 0) || this.defaultIdx ) {
            this.currIdx = this.defaultIdx;
            return;
        }
        // 2. check slots
        var slots = this.$slots['default']
        if(!!slots) {
            slots.find(vNode => {
                if (!vNode.componentOptions) { return false }
                var idx = vNode.componentOptions.propsData.idx;
                if (idx === undefined) { return false }
                this.currIdx = idx;
                return true;
            });
        }
    },
    computed: {
        sharedData() {
            let rtn = {}, odf = Object.defineProperty;
            // [PROVIDE] Shared variable
            odf(rtn, 'size'   , {get:()=>this.$_size});
            odf(rtn, 'shape'  , {get:()=>this.$_shape});
            odf(rtn, 'currIdx', {get:()=>this.currIdx});
            // odf(rtn, 'idxs'   , {get:()=>this.idxs});
            odf(rtn, 'navi'   , {get:()=>this.navigation});
            odf(rtn, 'addBtn' , {get:()=>this.addBtn});
            // [PROVIDE] Shared function
            odf(rtn, 'setIdx'    , {get:()=>this.setIdx});
            odf(rtn, 'onAddClick', {get:()=>this.onAddClick});
            
            // deprecated
            odf(rtn, 'underline', {get:()=>!!(this.shape==='underline' || this.underline)});
            return rtn;
        },
        // [COMPUTED] Props normalize : SIZE
        $_size() {
            // 1. check this.size
            if(this.size) {//'medium','small'
                if(this.size === 'medium') return 'medium'
                if(this.size === 'small' ) return 'small'
            }
            // 2. check flags
            if(this.medium) return 'medium'
            if(this.small ) return 'small'
            // 3. default value : 'medium'
            return 'medium'
        },
        // [COMPUTED] Props normalize : SHAPE
        $_shape() {
            // 1. check this.shape
            if(this.shape) { // 'border','underline','none' 
                if(this.shape === 'border'   ) return 'border'
                if(this.shape === 'underline') return 'underline'
                if(this.shape === 'none'     ) return 'none'
            }
            // 2. check flags
            if(this.border   ) return 'border'
            if(this.underline) return 'underline'
            // x. default value : 'border'
            return 'border'
        }
    },
    methods : {
        // @vuese
        // 탭의 페이지를 설정합니다.
        // #Set page index.
        // $arg: index of tab
        // $return: N/A
        setIdx(idx) {
            // 1. set index
            this.currIdx = idx;
            // 2. set scroll
            // this.adjustScroll(idx);
            // $ver: v0.1.0
            // $arg: index of tab
            // 탭이 이동되었을때 발생합니다.
            // #It fires when tab is changed.
            this.$emit("tab-change",idx);
            
            
        },
        
        adjustScroll(idx) {
            if(idx === undefined) return;
            if(!this.idxMap.has(idx)) return;
            var win = this.$refs.window;
            var scr = this.$refs.scroll;
            var lab = this.idxMap.get(idx).elm;
            var wRect = win.getBoundingClientRect();
            var lRect = lab.getBoundingClientRect();
            
            var nOffset = ~~scr.getAttribute('offset');
            var rPad = this.navigation * 72 + this.addBtn * 36;
            if(wRect.right - rPad < lRect.right) {
                nOffset += (lRect.right + rPad - wRect.right) + 30; // 30px = 그냥 오른쪽 패딩
                scr.style['margin-left'] = (-nOffset) + 'px';
                scr.setAttribute('offset',nOffset);
            } else if(wRect.left > lRect.left){
                nOffset += (lRect.left - wRect.left) - 20;          // 20px = 여긴 왜 20이지? 언제 눈치챌까?
                nOffset = nOffset > 0 ? nOffset : 0;
                scr.style['margin-left'] = (-nOffset) + 'px';
                scr.setAttribute('offset',nOffset);
            }
        },
        
        onAddClick(e) {
            this.$emit('add-tab',e);
        },
        getLabelNode(h, props) {
            var label = props.label, idx = props.idx, disable = !!props.disable
            return h('ur-tab-label',{props:{idx, disable}},[label]);
        }
    },
    render(h) {
        let slots = this.$slots.default;
        let labels = [], contents = [];
        // this.idxMap.clear();
        
        // 1. classify nodes
        slots.forEach(vNode=> {
            if(!vNode.componentOptions){ return; }
            let nodeName = vNode.componentOptions.Ctor.options.name;
            switch(nodeName) {
            case TAG_LABEL:
                // 1.1 label tags
                labels.push(vNode);
                // this.idxMap.set(vNode.componentOptions.propsData.idx, vNode);
                //idxs.push(vNode.componentOptions.propsData.idx)
                break;
            case TAG_CONTS:
                // 1.2 content tags
                // 1.2.1 content with label props
                var props = vNode.componentOptions.propsData;
                if(props.label) {
                    labels.push(this.getLabelNode(h,props))
                    // this.idxMap.set(props.idx, labels[labels.length-1]);
                }
                // 1.2.2 push to array
                contents.push(vNode);
                break;
            }
        });
        
        // 2. make window area -> label + navi(?)
        var labelWindow = [];
        labelWindow.push(h("div",{"class":"ur-tab__label-wrapper","ref":"scroll"}, labels));
        if(this.navigation || this.addBtn) {
            labelWindow.push(h(tabNavi))
        }
        
        // 3. do something
        // this.idxs = Array.from(this.idxMap.keys());
        
        // x. return all nodes
        return h("div",{"class":"ur-tab-box"},[
            h("div",{"class":"ur-tab__label-window","ref":"window"},labelWindow),
            h("div",{"class":"ur-tab__content-wrapper"},contents)
        ]);
    },
    provide(){ return {tabBox:this.sharedData} },
}
</script>
